import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import MessageCreateModal from './CreateMessageModal/MessageCreateModal';
import SecureMessageHeader from './Components/SecureMessageHeader';
import MessageListPage from './MessageListPage/MessageListPage';
import { markNotification } from 'services/notification/notificationService';
import { notificationAction } from 'redux/actions/notificationAction';
import { useSecureMessageContext } from './Context/SecureMessageContext';
import useCompanionCase from 'modules/cases/hooks/useCompanionCase';

const SecureMessage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { caseDetails } = useSecureMessageContext();
  const { companionList } = useCompanionCase(caseDetails?.case_id);
  const searchParams = new URLSearchParams(useLocation().search);
  const notifications = useSelector((state) => state?.notificationList?.notifications?.notifications);

  const [show, setShow] = useState(location?.state?.createMessage || searchParams.get('createMessage') ? { companion_link: false } : false);

  useEffect(() => {
    if (JSON.parse(window?.localStorage?.getItem('stateData'))?.secure_msg) {
      window.localStorage.removeItem('stateData');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state, window.localStorage]);

  useEffect(() => {
    markNotificationRead();
  }, [notifications]);

  const markNotificationRead = () => {
    const unReadNoti = notifications?.filter((v) => Boolean(v?.is_read) === false && v?.notification_type === 'secure_message');
    if (unReadNoti?.length > 0) {
      markNotification(
        true,
        unReadNoti?.map((v) => v.sk)
      )
        .then(() => dispatch(notificationAction('', 1000, '')))
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <GlobalLoader />
      <div className="message-wrap px-2 pb-3">
        <SecureMessageHeader setShow={setShow} />
        <MessageListPage />
        {show && (
          <MessageCreateModal
            show={show}
            setShow={setShow}
            companionLink={show?.companion_link}
            companionList={companionList}
            createInAllCompanions={show?.create_in_all_companions}
          />
        )}
      </div>
    </>
  );
};

export default SecureMessage;
